import React, { ChangeEvent, FC, useRef, useState } from 'react'
import { InputGroup, Input, Button, Box } from '@chakra-ui/react'
import { Icon } from '../icon'
import theme from '../../styles'
import { setCookie } from '../../scenarios'
import { ProviderInfo } from '../../state/interfaces'

interface providerAutocompleteProps {
  data: ProviderInfo[] | null
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}
export const ProviderAutoComplete: FC<providerAutocompleteProps> = ({ data, placeholder, onChange, name }) => {
  const inputElement = useRef<HTMLInputElement>(null)
  const [search, setSearch] = useState<{ text: string; suggestions: ProviderInfo[] }>({
    text: '',
    suggestions: [],
  })
  const [isComponentVisible, setIsComponentVisible] = useState(true)
  const onTextChanged = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    let suggestions: ProviderInfo[] = []
    if (value.length > 0) {
      const regex = new RegExp(`^${value}`, 'i')
      suggestions = data!.sort().filter((providerInfo: ProviderInfo) => regex.test(providerInfo.nameEn))
    }
    setIsComponentVisible(true)
    setSearch({ suggestions, text: value })
  }

  const suggestionSelected = (providerInfo: ProviderInfo) => {
    setIsComponentVisible(false)

    setSearch({
      text: providerInfo.nameEn,
      suggestions: [],
    })

    setCookie('providerNameReviews', providerInfo.nameEn)
    setCookie('providerSlugReviews', providerInfo.slugEn)
  }

  const { suggestions } = search

  return (
    <>
      <InputGroup>
        <Input
          ref={inputElement}
          autoComplete="off"
          value={search.text}
          aria-label={placeholder}
          placeholder={placeholder}
          onChange={onTextChanged}
          variant="none"
          fontSize={22}
          name={name}
          maxWidth={371}
          backgroundColor="transparent"
          _placeholder={{ color: 'green.500' }}
          layerStyle={theme.LayerStyles.INPUT}
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter' && !isComponentVisible && search.text != '') {
              ev.preventDefault()
              onChange && onChange([search.text])
            }
          }}
          autoFocus
        />
        {!isComponentVisible && search.text != '' && (
          <Button
            role={'button'}
            position="absolute"
            borderRadius="md"
            variant="none"
            layerStyle={theme.LayerStyles.BTN_INPUT_PILL}
            onClick={() => {
              onChange && onChange([search.text])
            }}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        )}
      </InputGroup>
      {suggestions.length > 0 && isComponentVisible && (
        <Box boxShadow="lg" borderRadius="md" backgroundColor="white" maxWidth={371}>
          {suggestions.map((item: ProviderInfo) => (
            <Button
              key={item.slugEn}
              onClick={() => suggestionSelected(item)}
              role="option"
              color="black"
              height={10}
              paddingX={5}
              borderRadius="0"
              fontSize="xxs"
              width="full"
              justifyContent="left"
              _hover={{
                color: 'purple',
                backgroundColor: 'purpleAlpha',
              }}
            >
              {item.nameEn}
            </Button>
          ))}
        </Box>
      )}
    </>
  )
}
